import React, { Component } from 'react';
import {Card, Row, Button, Container, Col} from 'react-bootstrap'
import Axios from 'axios'
import { connect } from 'react-redux';

class Help extends Component {
    state = { 
        email: '',
        message: '',
        submitEnabled: false,
        enquirySent: false,
        number: '',
        contactEmail: false,
        contactText: false,
        contactTelephone: false,
     }
     componentWillReceiveProps(next){
        if(next.user && next.user.email !== this.state.email){
            this.setState({email: next.user ? next.user.email : ''})
        }
     }
     componentWillMount(){
         if(this.props.user){
             this.setState({email: this.props.user.email})
         }
     }
     textChange=(e, type)=>{
        e.persist()
        let email = type === 'email' ? e.target.value : this.state.email 
        let messageExists = type === 'message' ? e.target.value !== '' : this.state.message !== ''
        let emailValid = this.validateEmail(email)
        let submitEnabled = emailValid && messageExists 
        this.setState({[type]: e.target.value, submitEnabled: submitEnabled})
    }
    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
     }
     handleSubmit = ()=>{
        Axios.post('/api/help/contact', this.state).then((res)=>{
           this.setState({
                enquirySent: res.data.success,
                email: '',
                message: '',
                number: '',
                submitEnabled: false,
                contactEmail: false,
                contactText: false,
                contactTelephone: false,
           })  
           setTimeout(()=>{
               this.setState({enquirySent: false})
           }, 10000)
        })
    }
    contactAuthChange=(e, type)=>{
        this.setState({[type]: e.target.value !== false})
     }
    render() { 
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <div style={{marginTop: '60px', marginBottom: '60px'}}>
            {this.props.user && <Card style={{width: '90%',margin: 'auto', display: 'block', marginTop: '40px'}}>
            <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{textAlign: 'center'}}>
                Guides
            </Card.Header>
            <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{textAlign: 'center'}}>
            </Card.Body>
        </Card>}
        <Card style={{width: '90%',margin: 'auto', display: 'block', marginTop: '40px'}}>
            <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{textAlign: 'center'}}>Contact Us</Card.Header>
            <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
            {this.props.user && <h4 style={{textAlign: 'center'}}><u>Cant find the answers your looking for?</u></h4>}
                <Container id='content'>
                    <Row style={{padding: '10px'}}>
                        <input style={{width: '80%'}} type='text' value={this.state.email} onChange={(e)=>this.textChange(e, 'email')} placeholder='email (required)' />
                    </Row>
                    <Row style={{padding: '10px'}}>
                        <input style={{width: '80%'}} type='text' value={this.state.number} onChange={(e)=>this.textChange(e, 'number')} placeholder='phone number (optional)' />
                    </Row>
                    <Row style={{padding: '10px'}}>
                        <textarea style={{width: '80%', height: '200px'}} type='text' value={this.state.message} onChange={(e)=>this.textChange(e, 'message')} placeholder='message (required)' />
                    </Row>
                    
                    <Row style={{padding: '10px'}}>
                        {!this.props.user && <div>
                        <p>Here at BreezeLabs we take your privacy seriously and 
                           will only use your personal information to administer 
                           your account and to provide the products and services 
                           you have requested from us.
                        </p>
                        <p>However, from time to time we would like to contact 
                           you with details of other products, offers, services 
                           and competitions we provide. If you consent to us contacting 
                           you for this purpose please tick to say how you would like us
                           to contact you:
                        </p>
                        <Col>
                            <label>Email</label>
                            <input checked={this.state.contactEmail} onChange={(e)=>{this.contactAuthChange(e, 'contactEmail')}} type='checkbox'/>
                        </Col>
                        <Col>
                            <label>Text message</label>
                            <input checked={this.state.contactText} onChange={(e)=>{this.contactAuthChange(e, 'contactText')}} type='checkbox'/>
                        </Col>
                        <Col>
                            <label>Telephone</label>
                            <input checked={this.state.contactTelephone} onChange={(e)=>{this.contactAuthChange(e, 'contactTelephone')}} type='checkbox'/>
                        </Col>
                        <p>If you would prefer not to hear from us, you can stop receiving our updated at any time by emailing us at <a href='mailto:breezelabsuk@gmail.com'>breezelabsuk@gmail.com</a>.</p>
                        <p>By clicking submit you agree to give us permission to contact you through the given contact details in terms for support.</p>
                        </div>}
                        
                        <Button onClick={this.handleSubmit} disabled={!this.state.submitEnabled} style={{backgroundColor: '#343a40'}}>Submit</Button>
                        {this.state.enquirySent && <p>Enquiry Sent</p>}
                    </Row>
                </Container>
            </Card.Body>
        </Card>
        </div>
         );
    }
}
function mapStateToProps(state){
    return{
        user: state.user
    }
}
export default connect(mapStateToProps)(Help);
